import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { theme } from "./theme";

export default function ProductCard({ product }) {
  const minPrice = Math.min(product.price14, product.price21);

  return (
    <CardLink to={`/product/${product.id}`}>
      <ImageWrap>
        <img src={product.imageUrl} alt={product.name} />
        {product.badge && <Badge>{product.badge}</Badge>}
      </ImageWrap>
      <Info>
        <Name>{product.name}</Name>
        <Desc>{product.shortDesc}</Desc>
        <Footer>
          <Price> €{minPrice?.toFixed(2)}</Price>
          <ShopBtn>Shiko →</ShopBtn>
        </Footer>
      </Info>
    </CardLink>
  );
}

const CardLink = styled(Link)`
  background: ${theme.colors.bgCard};
  border: 1px solid ${theme.colors.borderSubtle};
  border-radius: ${theme.radius.lg};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  transition:
    transform 0.35s cubic-bezier(0.16, 1, 0.3, 1),
    box-shadow 0.35s ease;
  cursor: pointer;
  width: 250px;
  @media (max-width: 920px) {
    width: 45%;
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  }
  @media (max-width: 750px) {
    width: 45%;
  }
`;

const ImageWrap = styled.div`
  position: relative;
  overflow: hidden;
  margin: auto;
  display: flex;
  width: 250px;
  justify-content: center;
  background: white;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: auto;
    align-self: center;
    transition: transform 0.5s ease;
  }

  ${CardLink}:hover & img {
    transform: scale(1.06);
  }
  @media (max-width: 920px) {
    width: 100%;
  }
`;

const Badge = styled.span`
  position: absolute;
  top: 12px;
  left: 12px;
  background: #89d146;
  color: white;
  font-size: 0.65rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 999px;
  font-family: ${theme.fonts.mono};
`;

const Info = styled.div`
  padding: 1.25rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  flex: 1;
  @media (max-width: 520px) {
    padding: 1rem 1rem 1rem;
  }
`;

const Name = styled.h3`
  font-family: "Playfair Display", serif;
  font-size: 1.25rem;
  color: ${theme.colors.textPrimary};
  margin: 0 0 0.4rem;
  font-style: italic;
  @media (max-width: 520px) {
    font-size: 0.9rem;
  }
`;

const Desc = styled.p`
  font-size: 0.82rem;
  color: ${theme.colors.textSecondary};
  line-height: 1.6;
  flex: 1;
  margin: 0 0 1rem;
  @media (max-width: 520px) {
    max-height: 10px;
    display: none;
    font-size: 0.6rem;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Price = styled.span`
  font-family: ${theme.fonts.mono};
  font-size: 0.85rem;
  color: #89d146;
  letter-spacing: 0.05em;
`;

const ShopBtn = styled.span`
  background: transparent;
  border: 1px solid ${theme.colors.border};
  color: ${theme.colors.textSecondary};
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  padding: 6px 16px;
  border-radius: 999px;
  font-family: ${theme.fonts.mono};
  transition: all 0.25s ease;
  @media (max-width: 520px) {
    font-size: 0.7rem;
    padding: 6px 0;
  }

  ${CardLink}:hover & {
    background: #89d146;
    border-color: #89d146;
    color: white;
  }
`;
